// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Ld4h","actions":"GroupTable_actions__2DsQx","deleteModalFooter":"GroupTable_deleteModalFooter__3Elqb"};